import _JSXStyle from "styled-jsx/style";
import React from 'react';

var EventLocation = function EventLocation(_ref) {
  var location = _ref.location;
  if (!location) return;
  if (typeof location === 'string') return /*#__PURE__*/React.createElement("div", {
    className: "jsx-1035074575"
  }, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1035074575"
  }, ["address.jsx-1035074575{font-style:normal;}"]), /*#__PURE__*/React.createElement("address", {
    className: "jsx-1035074575"
  }, location));
  var name = location.name,
      subLocation = location.location,
      address = location.address,
      description = location.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-1922900645"
  }, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1922900645"
  }, ["address.jsx-1922900645{font-style:normal;}"]), /*#__PURE__*/React.createElement("address", {
    className: "jsx-1922900645"
  }, name, " ", /*#__PURE__*/React.createElement("br", {
    className: "jsx-1922900645"
  }), subLocation, " ", /*#__PURE__*/React.createElement("br", {
    className: "jsx-1922900645"
  }), address), description && /*#__PURE__*/React.createElement("p", {
    className: "jsx-1922900645"
  }, description));
};

export default EventLocation;